import { render, staticRenderFns } from "./leftviews.vue?vue&type=template&id=2f15e5b7&scoped=true&"
import script from "./leftviews.vue?vue&type=script&lang=js&"
export * from "./leftviews.vue?vue&type=script&lang=js&"
import style0 from "./leftviews.vue?vue&type=style&index=0&id=2f15e5b7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f15e5b7",
  null
  
)

export default component.exports